import React from 'react';
import { motion } from 'framer-motion/dist/framer-motion';
import useViewport from '../../../utils/useViewPort';

function MotionContainer({ children }) {
  const { width } = useViewport();
  return (
    <>
      {width <= 750 ? (
        <>{children}</>
      ) : (
        <motion.div
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {children}
        </motion.div>
      )}
    </>
  );
}

export default MotionContainer;
